import React, { ComponentProps } from "react";

function LightBulbIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={8}
      height={13}
      viewBox="0 0 8 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="lightbulb.fill">
        <g id="Group">
          <path
            id="Vector"
            d="M2.37798 10.4249H5.6005C5.78252 10.4249 5.92163 10.279 5.92163 10.1015C5.92163 9.92632 5.78252 9.78125 5.6005 9.78125H2.37798C2.19597 9.78125 2.05273 9.92632 2.05273 10.1015C2.05273 10.279 2.19597 10.4249 2.37798 10.4249ZM3.98763 11.9166C4.78236 11.9166 5.42299 11.5304 5.47596 10.9465H2.49801C2.53769 11.5304 3.18788 11.9166 3.98763 11.9166Z"
          />
          <path
            id="Vector_2"
            d="M0.570312 3.1516C0.570312 5.06117 1.82107 5.6016 2.0071 8.87824C2.01714 9.11331 2.17103 9.26044 2.41431 9.26044H5.56008C5.8075 9.26044 5.95634 9.11331 5.97143 8.87824C6.15743 5.6016 7.405 5.06211 7.405 3.15251C7.405 1.37551 5.88816 0 3.9872 0C2.08625 0 0.570312 1.37461 0.570312 3.1516Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default LightBulbIcon;
